import { useNavigate } from 'react-router-dom';

import { S } from '@tf/utils';

import { useSelectedAccount } from '@/core/hooks';

export const useNavigateToEntity = () => {
	const navigate = useNavigate();
	const account = useSelectedAccount();

	const navigateToEntity = (
		connectionGraphId: number,
		connectionKind: string,
		entityGraphNodeId: number
	) => {
		window.scrollTo(0, 0);
		return navigate(
			`/accounts/${account.meta.graphNodeId}/${S.slugify(
				connectionKind
			)}/${connectionGraphId}/entity/${entityGraphNodeId}`
		);
	};

	return { navigateToEntity };
};
